import { ActionTypes } from "../constants/action-types";


export const userReducer = (state = {}, { type, payload })=>{
    switch (type) {
        case ActionTypes.ADD_USERS:
          return { ...state, users: payload };
        default:
          return state;
      }
}

export const selectedUserReducer = (state = {}, {type, payload})=>{
    switch (type) {
        case ActionTypes.SINGLE_USER:
          return { ...state, ...payload };
        case ActionTypes.REMOVE_SELECTED_USER:
            return { };
        default:
          return state;
      }
}